import { Injectable } from '@angular/core';

import { normalizeFilterIds, normalizeStringValue, objectToQueryString } from '../../common/utils';

import { environment } from '../../../environments/environment';

import { RestService } from './rest.service';

export interface AttendeeSearchFilters {
  committeeIds?: number[] | null;
  delegateTypeIds?: number[] | null;
  localIds?: number[] | null;
  search?: string;
}

@Injectable()
export class AttendeeService {
  constructor(private readonly rest: RestService) {}

  getAttendees(searchOrFilters: string | AttendeeSearchFilters = ''): Promise<any> {
    const query = objectToQueryString(this.normalizeSearchFilters(searchOrFilters));

    return this.rest.get(`${environment.apiUrl}/api/core/attendee${query}`);
  }

  getAttendeeById(id: number): Promise<any> {
    return this.rest.get(`${environment.apiUrl}/api/core/attendee/${id}`);
  }

  getAttendeeHistory(id: number): Promise<any> {
    return this.rest.get(`${environment.apiUrl}/api/core/attendee/${id}/history`);
  }

  createAttendee(payload: any): Promise<any> {
    return this.rest.post(`${environment.apiUrl}/api/core/attendee`, payload);
  }

  updateAttendee(id: number, payload: any): Promise<any> {
    return this.rest.put(`${environment.apiUrl}/api/core/attendee/${id}`, payload);
  }

  deleteAttendee(id: number): Promise<any> {
    return this.rest.delete(`${environment.apiUrl}/api/core/attendee/${id}`);
  }

  private normalizeSearchFilters(searchOrFilters: string | AttendeeSearchFilters): AttendeeSearchFilters {
    const filters = typeof searchOrFilters === 'string' ? { search: searchOrFilters } : searchOrFilters || {};

    return {
      committeeIds: normalizeFilterIds(filters.committeeIds),
      delegateTypeIds: normalizeFilterIds(filters.delegateTypeIds),
      localIds: normalizeFilterIds(filters.localIds),
      search: normalizeStringValue(filters.search),
    };
  }
}
